import { useState } from "react";
import SidebarComp from "../../../components/Sidebar";
import Header from "../../../components/Header";
import "../styles/employeeQueries.css";
import EmployeeQueries from "./EmployeeQueries";
import EmployeeQueriesList from "../components/EmployeeQueriesList";

const EmployeeQueriesHome = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [viewType, setViewType] = useState(0);





  return (
    <>
      <div className="dashboard-main-cover-wrapper">
        <Header />
        <div className="dashboard-inner-main-cover-wrapper">
          <div className="dashboard-sidebar">
            <SidebarComp setCollapsed={setCollapsed} collapsed={collapsed} />
          </div>
          <div
            className={
              collapsed
                ? "dashboard-content-cover-closed-wrapper"
                : "dashboard-content-cover-wrapper"
            }
          >
             <EmployeeQueries viewType={viewType} setViewType={setViewType}/>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeQueriesHome;
